/**
 * File-format types for the generated map assets. Consumers should only rely on
 * `WorldMap` (from @sa/sim) plus the optional `MapExtras` below.
 */
// @sa/sim has no package.json yet — import the contract by relative path.
import type { HexIdx, MapCity, MapCountry, MapRegion, WaterIdx, WorldMap } from '../../sim/src/world';
import type { RegionBalance } from './balance';
import type { Lattice } from './lattice';

export const WORLD_MAGIC = 'SAW1';
export const COAST_MAGIC = 'SAC1';
export const FORMAT_VERSION = 1;
/** Coast/border vertices are quantised to 1/COAST_QUANT mu. */
export const COAST_QUANT = 100;

export const WORLD_BIN = 'world.v1.bin';
export const WORLD_META = 'world.v1.meta.json';
export const COAST_BIN = 'coast.v1.bin';

/** Curated land link across a narrow strait (also present in the CSR link arrays). */
export interface MapStrait {
  name: string;
  a: HexIdx;
  b: HexIdx;
}

/** Forced naval link between two non-adjacent water hexes (also present in `wnbr`). */
export interface MapCanal {
  name: string;
  a: WaterIdx;
  b: WaterIdx;
}

export interface WorldMeta {
  format: number;
  mapVersion: string;
  regions: MapRegion[];
  cities: MapCity[];
  countries: MapCountry[];
  straits: MapStrait[];
  canals: MapCanal[];
  regionBalance: RegionBalance[];
}

/** Data beyond the `WorldMap` contract, derived or carried by @sa/mapdata. */
export interface MapExtras {
  lattice: Lattice;
  /** per lattice cell (row-major, rows*cols): land hex index ≥ 0, or −1 − waterIdx */
  cellIndex: Int32Array;
  straits: MapStrait[];
  canals: MapCanal[];
  /** per water hex: 1 if part of the main ocean nav component (reachable by ships from any port) */
  navigable: Uint8Array;
  /** per-region balance metrics + suggested capScale (computed by mapgen, informational) */
  regionBalance: RegionBalance[];
}

export type LoadedWorld = WorldMap & { extras: MapExtras };

export interface EncodedWorld {
  bin: Uint8Array;
  meta: WorldMeta;
  coast: Uint8Array;
}
